import type { ComponentType } from 'react';
import { MARKETING_IMAGES, type MarketingImageId } from '@/data/marketingAssets';

interface Props {
  id: MarketingImageId;
  /** Mockup-Komponente, die gerendert wird, wenn kein Screenshot vorhanden ist. */
  mockupComponent: ComponentType;
  /** Alt-Text für das gerenderte <img>-Tag (Fallback nur). */
  alt: string;
  /** Wenn true → eager-loading (für Hero-Bild). Sonst lazy. */
  eager?: boolean;
  /** Optionale Pixel-Maße für CLS-Schutz beim Bild-Fallback. */
  width?: number;
  height?: number;
  className?: string;
}

/**
 * Phase 14 — Wrapper, der entweder einen echten Screenshot aus
 * {@code public/marketing/} rendert (wenn im {@link MARKETING_IMAGES}-Manifest
 * gemappt) oder auf den jeweiligen SVG-Mockup zurückfällt.
 */
export function MarketingImage({
  id,
  mockupComponent: Mockup,
  alt,
  eager = false,
  width,
  height,
  className,
}: Props) {
  const path = MARKETING_IMAGES[id];
  if (path) {
    return (
      <img
        src={path}
        alt={alt}
        loading={eager ? 'eager' : 'lazy'}
        width={width}
        height={height}
        className={['h-auto w-full rounded-xl shadow-2xl', className ?? ''].join(' ')}
      />
    );
  }
  return (
    <div className={className} role="presentation">
      <Mockup />
    </div>
  );
}
